import { type AppState } from '../../../types';

export const getMessage = (state: AppState) => state.MESSAGE;
